/**
 * advisorLandingAccess — fail-closed Feature-Flag für das
 * Advisor-Cockpit-First-Landing (M-ACF-1, `architecture-advisor-cockpit-first.md`
 * §3.3 / §7.1).
 *
 * Ein eigenes, separat flippbares Flag (bewusst NICHT an `isLoopBBeta`
 * gekoppelt, §3.3): Rollback der Landing darf nicht die Loop-B-Beta abschalten
 * und ein Loop-B-GA-Flip darf nicht implizit das Login-Verhalten aller Advisor
 * ändern.
 *
 * Firebase-frei (nur `process.env`) — importierbar aus `config/navigation.ts`
 * und `utils/advisorLandingSession.ts`, die selbst KEIN Firebase ziehen dürfen
 * (Muster `config/cockpitAccess.ts`).
 *
 * @module config/advisorLandingAccess
 */

/**
 * Feature-Flag für das Advisor-Landing. Fail-closed: nur bei explizitem
 * `'true'` aktiv. Modul-Konstante, einmalig beim Bundle-Load ausgewertet
 * (Muster `UX_COCKPIT_ENABLED`). Fehlt/leer/≠ `'true'` ⇒ `false` ⇒ das gesamte
 * Landing-Feature ist inert (Gate reicht Children durch, Nav-Prädikat
 * byte-identisch, keine Storage-Zugriffe).
 */
export const ADVISOR_LANDING_ENABLED: boolean =
  process.env.REACT_APP_ADVISOR_LANDING_ENABLED === 'true';
